import { ConfigProvider } from "antd";
import LoaderGif from "assets/images/Logo.svg";
import ContactButton from "components/common/ContactUsButton";
import { TableContainerProvider } from "customHooks/tableScrollerContext";
import { CustomThemeProvider } from "customHooks/ThemeContext";
import React, { lazy } from "react";
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-phone-input-2/lib/style.css';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.min.css';
import { ThemeProvider } from "styled-components";
// import Testing from "pages/Testing";

const AppRoutes = lazy(() => import('routes/Routes'));

function App() {
  return (
    <React.Suspense
      fallback={
        <div
          className="h-screen w-screen bg-white dark:bg-dark130 flex items-center justify-center"
        >
          <img src={LoaderGif} className="animate-fade w-[200px]" alt="Loading..." />
        </div>
      }
    >
      <CustomThemeProvider>
        <ThemeProvider
          theme={
            {
              primary: "#323C60"
            }
          }>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#323C60",
                colorPrimaryActive: "#323C60",
              },
            }}
          >
            <TableContainerProvider>
              <AppRoutes />
            </TableContainerProvider>
            <ContactButton />
            <ToastContainer />
          </ConfigProvider>
        </ThemeProvider>
      </CustomThemeProvider>
    </React.Suspense>
  );
}

export default App;
